<div class="range-container">
  <div class="slider">
    <div class="selected-area" [ngStyle]="{ width: left + '%' }"></div>
    <div
      *ngIf="!indicator"
      class="pointer"
      [ngStyle]="{
        color: value < 100 ? '#fb0505' : '#44c034',
        left: 'calc(' + left + '% - 12px)'
      }"
    >
      <mat-icon aria-hidden="false" aria-label="range value"
        >arrow_drop_up</mat-icon
      >
      <span
        class="label"
        [ngStyle]="{ left: value < 10 ? '8px' : value < 100 ? '4px' : 0 }"
        ><span></span>{{ value }}%</span
      >
    </div>

    <!-- ONLY FOR LEGEND -->
    <div
      *ngIf="indicator"
      class="pointer"
      [ngStyle]="{
        color: '#fb0505',
        left: 0
      }"
    >
      <mat-icon aria-hidden="false" aria-label="range value"
        >arrow_drop_up</mat-icon
      >
      <span class="label" [ngStyle]="{ left: '-10px', color: '#fb0505' }"
        ><span></span></span
      >
    </div>
    <div
      *ngIf="indicator"
      class="pointer"
      [ngStyle]="{
        color: '#44c034',
        left: '50%'
      }"
    >
      <mat-icon aria-hidden="false" aria-label="range value"
        >arrow_drop_up</mat-icon
      >
      <span class="label" [ngStyle]="{ left: '-10px', color: '#44c034' }"
        ><span></span></span
      >
    </div>
    <div
      *ngIf="indicator"
      class="pointer"
      [ngStyle]="{
        color: '#44c034',
        left: '96%'
      }"
    >
      <mat-icon aria-hidden="false" aria-label="range value"
        >arrow_drop_up</mat-icon
      >
      <span class="label" [ngStyle]="{ left: '-10px', color: '#44c034' }"
        ><span></span></span
      >
    </div>
  </div>
</div>
